import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import { elements } from '../xfiles/styles.js'

const destinations = new WeakMap()
const origins = new WeakMap()
const wrappers = new WeakSet()

const getWrapper = (
  element
) => {
  const wrapper = closest('[data-contract~="upload.paired"]', element)
  
  if (wrapper && wrappers.has(wrapper)) {
    return wrapper
  }
}

export const destination = (
  destination
) => {
  const wrapper = getWrapper(destination)
  
  if (wrapper) {
    destinations.set(wrapper, destination)
  }
}

export const origin = (
  origin,
  opener = null
) => {
  const wrapper = getWrapper(opener ?? origin)
  
  if (wrapper) {
    origins.set(wrapper, origin)
  }
}

export const move = (
  origin
) => {
  const wrapper = getWrapper(origin)
  const destination = destinations.get(wrapper)
  
  if (destination && origins.get(wrapper) === origin) {
    const list = one(`.${elements.xfiles_list}`, origin)
    const { children } = list
    
    append(destination, ...children)
  }
}

export default (
  wrapper
) => {
  wrappers.add(wrapper)
  
  queueMicrotask(async () => {
    await removed(wrapper)
    destinations.delete(wrapper)
    origins.delete(wrapper)
    wrappers.delete(wrapper)
  })
}
